import { Component, OnInit, NgZone, Inject } from '@angular/core';
import { LocalStorageKeyEnum } from '../localStorage.key.enum';
import { UserService } from '../services/user.service';
import * as _ from 'lodash';
import { AuthService } from '../services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription, timer, Subject  } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// Required for MSAL
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionType, PopupRequest } from '@azure/msal-browser';
import { DomSanitizer } from '@angular/platform-browser';

declare const google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apcAuthSrv: AuthService,
    private userService: UserService,
    private ngZone: NgZone,

    @Inject(MSAL_GUARD_CONFIG) private readonly configurazioneGuardiaMsal: MsalGuardConfiguration,
    private readonly servizioAutenticazione: MsalService,
    public http: HttpClient,
    private sanitizer: DomSanitizer

  ) { }

  user: any;
  loggedIn: boolean;
  returnUrl: string;
  subTime: Subscription = Subscription.EMPTY;

  loginDisplay = false;
  tokenExpiration: string = '';

   private readonly distruggi$ = new Subject<void>();
  isAccessoInCorso = false; // Flag per indicare se il processo di login è attivo

  ngOnInit() {

    this.apcAuthSrv.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard/orders';
    if (this.subTime) {
      this.subTime.unsubscribe();
    }

  }

  isLogged():boolean{
    return this.servizioAutenticazione.instance.getActiveAccount() != null;
  }

  avviaLoginPopup() {
    if (this.configurazioneGuardiaMsal.interactionType === InteractionType.Popup) {
      this.servizioAutenticazione.loginPopup({ ...this.configurazioneGuardiaMsal.authRequest } as PopupRequest)
        .subscribe({
          next: (response:AuthenticationResult) => {
            this.servizioAutenticazione.instance.setActiveAccount(response.account);
          //  console.log('Popup di login completato');
            this.handleCredentialResponseMS(response);
          },
          error: (errore) => {
            console.error('Errore durante il popup di login', errore);
          }
        });
    } else {
      console.warn('La configurazione della guardia non prevede l\'utilizzo di popup.');
      //implementare un fallback per il login tramite redirect
    }
  }

  ngOnDestroy(): void {
    this.distruggi$.next(void 0);
    this.distruggi$.complete();
  }


  checkPermission(credential) {
    this.userService.getIdentity(credential).then((permissions) => {
      localStorage.setItem(LocalStorageKeyEnum.ROLE, JSON.stringify({ role: permissions.role }));
      this.router.navigateByUrl(this.returnUrl);
    })
      .catch((error) => console.error(error));
  }
 
  ngAfterViewInit() {
   // this.initializeGoogleLogin();
  }

  initializeGoogleLogin() {
    if(google != typeof undefined && google != null){
      if(google.accounts != typeof undefined && google.accounts != null){
        if(google.accounts.id != typeof undefined && google.accounts.id != null){
          google.accounts.id.initialize({
            client_id: environment.googleAuthClientId,
            callback: data => this.handleCredentialResponse(data),
            itp_support: true,
            auto_select: true
          });
          // customization attributes
          if (document.getElementById("googleBtn")) {
            // google.accounts.id.renderButton(
            //   document.getElementById("googleBtn"),
            //   {
            //     type: "standard",
            //     theme: "outline",
            //     size: "large",
            //     width: "400",
            //     shape: "square",
            //     locale: "en_UK",
            //     logo_alignment: "center",
            //   }
            // );
            google.accounts.id.renderButton(
              document.getElementById("googleBtn"),
              {
                theme: "outline",
                size: "large",
              }
            );
          }
          google.accounts.id.prompt(this.callbackPrompt.bind(this));
        }
      }
    }
    
  }

  callbackPrompt(notification) {
    if ((notification.isNotDisplayed() || notification.isSkippedMoment()) && window.location?.pathname?.split("/")?.[1] !== "login") {
      console.log("One Tap prompt or the browser native credential manager are not avaible.");
      this.apcAuthSrv.logout();
      this.ngZone.run(() => {
        this.router.navigate(["/login"]);
      });
    }
  }

  handleCredentialResponse(response: any) {
  //  console.log(response);
    this.ngZone.run(() => {
      this.user = response;
      this.loggedIn = response != null;
      let base64Url = response?.credential?.split('.')[1];
      let base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
      let jsonPayload = JSON.parse(decodeURIComponent(atob(base64)?.split('')?.map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('')));

      let userLogin = {}
      userLogin = { ...jsonPayload, "idToken": response.credential }
    //  console.log(userLogin);
      localStorage.setItem(LocalStorageKeyEnum.USER, JSON.stringify(userLogin));
      this.checkPermission(response.credential);

      let exp = jsonPayload?.exp || "";
      if (exp) {
        let expMill = new Date(exp * 1000).getTime() - new Date().getTime();
        let timerExp = timer(expMill);
        if (this.subTime) {
          this.subTime.unsubscribe();
        }
        this.subTime = timerExp.subscribe(() => {
          this.apcAuthSrv.logout();
          this.initializeGoogleLogin();
        });
      }
    });
  }


  handleCredentialResponseMS(response: any) {
    this.ngZone.run(() => {
      this.user = response;
      this.loggedIn = response != null;
      let base64Url = response['idToken'].split('.')[1];
      let base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
      let jsonPayload = JSON.parse(decodeURIComponent(atob(base64)?.split('')?.map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('')));

      let userLogin = {};
      userLogin = { ...jsonPayload, "idToken": response['idToken'] };

      let tht = this;
      this.http.get('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: { 'Content-Type': 'image/*', 'Authorization': 'Bearer ' + response['accessToken'] },
        responseType: 'arraybuffer',
      })
      .toPromise()
      .then(
        (data) => {
          const TYPED_ARRAY = new Uint8Array(data);
          // converts the typed array to string of characters
          const STRING_CHAR = String.fromCharCode.apply(null, TYPED_ARRAY);

          //converts string of characters to base64String
          let base64String = btoa(STRING_CHAR);

          //sanitize the url that is passed as a value to image src attrtibute
          let avatar = tht.sanitizer.bypassSecurityTrustUrl(
            'data:image/*;base64, ' + base64String
          );

          userLogin = { ...userLogin, "photoBlob": avatar };
          
          localStorage.setItem(LocalStorageKeyEnum.USER, JSON.stringify(userLogin));

          tht.checkPermission(userLogin['idToken']);

        let exp = jsonPayload?.exp || "";
        if (exp) {
          let expMill = new Date(exp * 1000).getTime() - new Date().getTime();
          let timerExp = timer(expMill);
          if (tht.subTime) {
            tht.subTime.unsubscribe();
          }
          tht.subTime = timerExp.subscribe(() => {
            tht.apcAuthSrv.logout();
          });
        }
          
      })
      .catch(function (err) {

          localStorage.setItem(LocalStorageKeyEnum.USER, JSON.stringify(userLogin));
          tht.checkPermission(userLogin['idToken']);

        let exp = jsonPayload?.exp || "";
        if (exp) {
          let expMill = new Date(exp * 1000).getTime() - new Date().getTime();
          let timerExp = timer(expMill);
          if (tht.subTime) {
            tht.subTime.unsubscribe();
          }
          tht.subTime = timerExp.subscribe(() => {
            tht.apcAuthSrv.logout();
          });
        }
      });

    });
  }

}
